var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500MlE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 57,
    viewBox: "0 0 27 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0095DF",
    d: "M26 22v30l-2 2-3 1H4l-1-1-2-2V21h25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    d: "M22.09 9.942v-6.26A3.686 3.686 0 0 0 18.41 0H8.591a3.687 3.687 0 0 0-3.683 3.682v6.261a6.095 6.095 0 0 0-3.112 1.673A6.097 6.097 0 0 0 0 15.954v34.363a6.143 6.143 0 0 0 6.136 6.137h14.728A6.144 6.144 0 0 0 27 50.317V15.954c0-2.962-2.112-5.44-4.91-6.012zM7.364 3.682c0-.677.55-1.227 1.228-1.227h9.818c.676 0 1.227.55 1.227 1.227v6.136H7.363V3.682zm17.182 42.954v3.681A3.687 3.687 0 0 1 20.864 54H6.136a3.687 3.687 0 0 1-3.681-3.683V21.8h22.09v24.837zm0-27H2.455v-3.682c0-.984.382-1.908 1.077-2.603a3.656 3.656 0 0 1 2.602-1.077l14.73-.001a3.686 3.686 0 0 1 3.681 3.681v3.682z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500MlE);
export default __webpack_public_path__ + "static/media/500_ml_e.79bc5443156f5140fac7237e5dfb8f09.svg";
export { ForwardRef as ReactComponent };